import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigateBack",style:(_vm.customizedPadding)},[_c(VBtn,{staticClass:"dense",attrs:{"rbt-target":"goBack","large":""},on:{"click":_vm.sendToWorkspaces}},[_c(VIcon,[_vm._v("navigate_expand_collapse_left")])],1),_c('org-logo',{attrs:{"organization-id":_vm.organizationId,"small":"","no-padding":"","redirects":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }